export default "__VITE_ASSET__R8SEQyIC__"